import carte from '@amo/core/assets/images/AMO_Icons/Carte_Grise.svg';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import moment from 'moment';

export const DeclarationFormation = (props) => {
    const { nextQuestion, data, datePermisB } = props;
    const isNonEligible = _.get(data, 'DemandeTarif[ListePersonnes][0][Formation]') === '0' && datePermisB.isSameOrAfter(moment('2011-01-01')); // Cas bloquant

    return (
        <Question asFieldset
            icon={carte}
            title={
                'Vous déclarez avoir réalisé <b>la formation de 7h</b> pour conduire ce <b>type de véhicule</b>&nbsp;?'
            }
        >
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[ListePersonnes][0][Formation]'}
                        value={'1'}
                        label={'Oui'}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[ListePersonnes][0][Formation]'}
                        value={'0'}
                        label={'Non'}
                    />
                </div>
            </div>

            {isNonEligible && (
                <div className="alert alert-danger mt-3 col-lg-8 offset-lg-2" role="alert">
                    <b>Vous pouvez conduire une moto 125cm³ avec un permis B si vous remplissez les 2 conditions
                        suivantes :</b><br />
                    - Vous avez le permis B depuis au moins 2 ans<br />
                    - Vous avez suivi une formation pratique de 7 heures<br /><br />
                    <b>Vous pouvez conduire un scooter 3 roues de la catégorie L5e avec un permis B si vous remplissez
                        les 3 conditions suivantes :</b><br />
                    - Vous avez le permis B depuis au moins 2 ans<br />
                    - Vous avez 21 ans ou plus<br />
                    - Vous avez suivi une formation pratique de 7 heures<br /><br />
                    <b>Vous êtes dispensé de suivre la formation dans les 2 cas suivants :</b><br />
                    - Vous avez obtenu votre permis B (avec l'équivalence A1) avant mars 1980<br />
                    - Vous avez conduit une 125cm³ ou un scooter 3 roues de la catégorie L5e entre 2006 et 2010<br />
                    - Si vous avez suivi la formation de 3 heures avant 2011
                </div>
            )}

            <button
                className={`btn btn-primary btn-arrow mt-4 ${isNonEligible ? 'disabled' : ''}`}
                onClick={() => !isNonEligible && nextQuestion()}
            >
                Continuer
            </button>
        </Question>
    );
};
